import { Component, OnInit } from '@angular/core';
import { IdP } from '../models/idp';
import { Alert } from '../shared/alert';
import { AppTitle } from '../shared/title';
import { ActivatedRoute, Router } from '@angular/router';
import { IdentityService } from '../services/identity.service';
import { Subscription } from 'rxjs';
import { SAML2Config } from '../models/saml2_config';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { FindIdP } from '../models/find_idp';
import { controlErrors } from '../shared/app.validators';
import { SAML2Attribute } from '../models/saml2_attribute';
import { DropdownOption } from '../shared/dropdown_option';

@Component({
  selector: 'app-add-edit-attribute',
  template: `
    <div class="row" [hidden]="msgHead.msg == ''">
      <div class="col-lg-8 col-md-6 col-xs-12">
          <alert [alert]="msgHead"></alert>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
        <div class="col-lg-12 col-md-12 col-xs-12" style="padding:0px; margin-bottom:0px;">
            <form [formGroup]="form" novalid>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-xs-12" style="margin-bottom: 0px;">
                        <div class="form-group">
                            <p class="custom-label">Label - Used for display purpose only</p>
                            <input type="text" [(ngModel)]="data.label" formControlName="label" class="form-control" placeholder="Label" title="Label">
                        </div>

                        <div class="form-group">
                            <p class="custom-label">Name - Actual Attribute Name in SAML Response</p>
                            <input type="text" [(ngModel)]="data.name" formControlName="name" class="form-control" placeholder="Name" title="Name">
                        </div>

                        <div class="form-group">
                            <p class="custom-label">User Attribute Mapping</p>
                            <select [(ngModel)]="data.userAttributeMapping" formControlName="userAttributeMapping" class="form-control" title="User Attribute Mapping">
                                <option *ngFor="let uam of userAttributeMappingList; let i = index" [value]="uam.id">{{uam.title}}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label class="custom-label">Skip If Blank</label><br/>
                            <app-toggle [(toggle)]="data.skipIfBlank"></app-toggle>
                        </div>

                        <div class="form-group">
                            <a style="cursor:pointer;" (click)="switchAdvancedSettings()">{{ showAdvancedSettings ? 'Hide' : 'Show' }} Advanced Settings</a>
                        </div>

                        <div *ngIf="showAdvancedSettings">
                            <div class="form-group">
                                <label class="custom-label">Default Values - When values are empty in SAML Response then this will be used instead</label>
                                <textarea style="width:auto;" class="form-control" [(ngModel)]="data.defaultValues" formControlName="defaultValues" placeholder="Default Values" title="Default Values" rows="4" cols="80"></textarea>
                            </div>

                            <div class="form-group">
                                <label class="custom-label">Instead Values - If typed then this will replace the actual values from SAML response</label>
                                <textarea style="width:auto;" class="form-control" [(ngModel)]="data.values" formControlName="values" placeholder="Instead Values" title="Instead Values" rows="4" cols="80"></textarea>
                            </div>

                            <div class="form-group">
                                <p class="custom-label">Attribute Validations Regex</p>
                                <input type="text" [(ngModel)]="data.attributeValidationsRegex" formControlName="attributeValidationsRegex" class="form-control" placeholder="Attribute Validations Regex" title="Attribute Validation Regex">
                            </div>

                            <div class="form-group">
                                <p class="custom-label">Attribute Transformations Regex</p>
                                <input type="text" [(ngModel)]="data.attributeTransformationsRegex" formControlName="attributeTransformationsRegex" class="form-control" placeholder="Attribute Transformations Regex" title="Attribute Transformations Regex">
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-lg-12 col-md-12 col-xs-12" style="margin-top:0px;">
            <button type="button" class="btn btn-large btn-primary" (click)="save()">Save</button>
            <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
        </div>
    </div>
    <div *ngIf="hasAccess" class="row">
        <div class="col-lg-6 col-md-6 col-xs-12">
            <alert [alert]="msg" style="display:block;"></alert>
        </div>
    </div>
  `,
})
export class AddEditAttributeComponent implements OnInit {
    msg: Alert;
    msgHead: Alert;
    acctNumber: string;
    hasAccess: boolean;
    idParam: string;
    nameQueryParam: string;
    private subscriptionQueryParams: Subscription;
    data: SAML2Attribute;
    editAttrIndexParam: string;
    editMode: boolean;
    editAttrInx: number;

    form: FormGroup;
    samlcfg: SAML2Config;
    userAttributeMappingList: DropdownOption[];
    showAdvancedSettings: boolean;

    constructor(private title: AppTitle, private activatedRoute: ActivatedRoute, private idsvc: IdentityService, private router: Router, fb: FormBuilder) {
        this.hasAccess = true;
        this.editMode = false;
        this.msg = new Alert();
        this.msgHead = new Alert();
        this.subscriptionQueryParams = activatedRoute.queryParams.subscribe(
			(params) => {
                this.nameQueryParam = params['name'];
			}
        );
        this.data = new SAML2Attribute();

        this.form = fb.group({
            label: ['', Validators.compose([Validators.required])],
            name: ['', Validators.compose([Validators.required])],
            userAttributeMapping: ['',  Validators.compose([Validators.required])],
            defaultValues: [''],
            values: [''],
            attributeValidationsRegex: [''],
            attributeTransformationsRegex: ['']
        });
        this.showAdvancedSettings = false;
        this.userAttributeMappingList = [
            { id: '', title: 'Select User Attribute Mapping'},
            { id: 'username', title: 'Username' },
            { id: 'first_name', title: 'First Name' },
            { id: 'last_name', title: 'Last Name' },
            { id: 'group_names', title: 'Group Names' },
            { id: 'card_id', title: 'Card ID' },
            { id: 'phone_number', title: 'Phone Number' },
        ];
    }

    ngOnInit() {
        let titleStr = 'Add New';
        this.idParam = this.activatedRoute.snapshot.params['id'];
        this.acctNumber = this.activatedRoute.snapshot.params['acctNumber'];
        this.editAttrIndexParam = this.activatedRoute.snapshot.params['attributeName'];
        if (this.acctNumber != null) {
            this.idsvc.validateAcctNumber(this.acctNumber)
                .subscribe(res => {
                    if (!res) {
                        this.msgHead.error(`You don't have access to this district number ${this.acctNumber}`);
                        this.hasAccess = false;
                    }
                }, err => {
                    console.log(err);
                    let e = this.idsvc.getUserErrorDefault(err);
                    this.msgHead.error(e);
                    this.hasAccess = false;
                })
        }
        if (this.editAttrIndexParam) {
			this.editMode = true;
			this.loadData();
			titleStr = 'Edit';
		}
        this.title.setTitles({
            title: titleStr + ' - Attribute',
            dashboard: titleStr + ' - Attribute'
        });

        this.title.setBreadcrumbs([
            { title: 'Identity Providers ', link: `/idp/${this.acctNumber}/idps` },
            { title: decodeURIComponent(this.nameQueryParam) + ' ', link: `/idp/${this.acctNumber}/idps/${this.idParam}/edit` },
            { title: 'Config ', link: `/idp/${this.acctNumber}/idps/${this.idParam}/config?name=${this.nameQueryParam}` },
            { title: titleStr + ' Attribute', link: `` }
        ]);
        this.loadData();
    }

    loadData() {
        let req = new FindIdP();
        req.id = parseInt(this.idParam);
        this.idsvc.saml2ConfigApi(this.acctNumber, req)
            .subscribe((saml2cfg: SAML2Config) => {
                this.samlcfg = saml2cfg;
                if (this.editAttrIndexParam) {
                    let inx = parseInt(this.editAttrIndexParam)-1;
                    this.data = saml2cfg.attributes[inx];
                    this.editAttrInx = inx;
                    if (this.data.values != "" || this.data.defaultValues != "" || this.data.attributeValidationsRegex != "" || this.data.attributeTransformationsRegex != "") {
                        this.showAdvancedSettings = true;
                    }
                }
            }, err => {
                console.log(err);
                if (this.idsvc.isErrNotFound(err)) {
                this.msg.warning(this.idsvc.getUserError(err));
                } else {
                    if (this.idsvc.isErrUnauthorized(err)) {
                        this.hasAccess = false;
                        this.msg.error(this.idsvc.getUserErrorDefault(err));
                    } else {
                        this.msg.error(this.idsvc.getUserErrorDefault(err));
                    }
                }
            });
    }

    save() {
        if (!this.form.valid) {
			this.displayErrors(this.form);
			return;
        }
        let attr = new SAML2Attribute();
        if (this.editAttrIndexParam && this.editMode) {
            attr = this.data;
        }
        attr.label = this.form.get('label').value;
        attr.name = this.form.get('name').value;
        attr.userAttributeMapping = this.form.get('userAttributeMapping').value;
        attr.skipIfBlank = this.data.skipIfBlank;
        attr.defaultValues = this.form.get('defaultValues').value;
        attr.values = this.form.get('values').value;
        attr.attributeValidationsRegex = this.form.get('attributeValidationsRegex').value;
        attr.attributeTransformationsRegex = this.form.get('attributeTransformationsRegex').value;

        if (this.editAttrIndexParam && this.editMode) {
            this.samlcfg.attributes[this.editAttrInx] = attr;
        } else {
            this.samlcfg.attributes.push(attr);
        }

        this.idsvc.saveSaml2ConfigApi(this.acctNumber, parseInt(this.idParam), this.samlcfg)
			.subscribe(res => {
                this.router.navigate([`/idp/${this.acctNumber}/idps/${this.idParam}/config`], { queryParams: { name: this.data.name } });
		        return;
            }, err => {
                console.log(err);
                let e = this.idsvc.getUserErrorDefault(err);
                this.msgHead.error(e);
            });
    }

    switchAdvancedSettings() {
        this.showAdvancedSettings = !this.showAdvancedSettings;
    }

    displayErrors(f: FormGroup) {
		var message = '';
		controlErrors(f, (c: any, err: any) => {
			message += err + '<br>';
		});
		this.msg.errorHtml(message);
	}

    goBack() {
		this.router.navigate([`idp/${this.acctNumber}/idps/${this.idParam}/config`], { queryParams: { name: this.nameQueryParam } });
		return;
	}
}
